export default "__VITE_ASSET__fc3173b1__"